// @core/api/endpoints/team/acknowledge_schedule_rotation.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AcknowledgeScheduleRotationRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Acknowledge rotation handoff
 * Performs acknowledge operation on schedule rotation.
 */
export async function AcknowledgeScheduleRotation(
  team_id: string,
  schedule_id: string,
  data: AcknowledgeScheduleRotationRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/schedules/:schedule_id/acknowledge`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':schedule_id', encodeURIComponent(schedule_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
